"use strict";

export default {
  subscriptionDetail(state) {
    return state.subscriptionDetail;
  },

  hasSubscription(state) {
    if (!state.subscriptionDetail || state.subscriptionDetail.length === 0) {
      return false;
    } else {
      const endDate = new Date(state.subscriptionDetail[0].end_date);
      const currentDate = new Date();
      if (currentDate > endDate) {
        return false;
      } else {
        return true;
      }
    }
  },
};
